import type { QueryClient } from "@tanstack/react-query";

import {
  allCountKeys,
  allRequestListKeys,
  invalidateQueryKeys,
  projectRequestStatisticsKeys,
} from "../../../hooks/queryKeys";

export const QUEUE_AUTOMATION_DELAY_MS = 1500;

export function invalidateStatusChangeQueries(queryClient: QueryClient): void {
  invalidateQueryKeys(queryClient, [...allRequestListKeys, ...allCountKeys]);
  queryClient.invalidateQueries({ queryKey: projectRequestStatisticsKeys.all });
}

export function scheduleQueueAutomationRefetch(
  queryClient: QueryClient,
  extraQueryKeys: readonly (readonly unknown[])[] = [],
): void {
  setTimeout(() => {
    invalidateStatusChangeQueries(queryClient);
    for (const queryKey of extraQueryKeys) {
      queryClient.invalidateQueries({ queryKey });
    }
  }, QUEUE_AUTOMATION_DELAY_MS);
}
